import { useBuilderNode } from '../../hooks/useBuilderNode';

export const TextDebugOverlay = () => {
  const { selectedNode, getTextDebugInfo } = useBuilderNode();

  if (!selectedNode || selectedNode.type !== 'text') return null;

  const dbg = getTextDebugInfo(selectedNode.id);
  if (!dbg) return null;

  return (
    <div className="absolute bottom-2 left-1/3 z-50 px-2.5 py-1.5 bg-yellow-50/95 border border-yellow-200 rounded text-[10px] font-mono text-yellow-800 space-y-0.5 pointer-events-none">
      <div>Fabric text width: <strong>{dbg.textWidth?.toFixed(2)}</strong></div>
      <div>Canvas2D measured: <strong>{dbg.directMeasure?.toFixed(2)}</strong></div>
      <div>Bounding box: <strong>{(dbg.curveVisualWidth ?? dbg.boundingBoxWidth)?.toFixed(2)} × {(dbg.curveVisualHeight ?? dbg.fabricHeight)?.toFixed(2)}</strong></div>
      <div>Layer width: <strong>{dbg.layerWidth?.toFixed(2)}</strong></div>
      <div>Font size: {dbg.fontSize} | Spacing: {dbg.charSpacing}</div>
      <div>Height: {dbg.fabricHeight?.toFixed(2)} | Lines: {dbg.textLines}</div>
      {dbg.curvePreset !== 'none' && (
        <div className="border-t border-yellow-200 pt-0.5 mt-0.5">Curve: <strong>{dbg.curvePreset}</strong>{dbg.curveRadius != null && <> | Radius: {dbg.curveRadius}</>}</div>
      )}
    </div>
  );
};
